import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const ProBadge = () => (
  <TooltipProvider delayDuration={200}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="ml-1 inline-flex items-center px-1.5 py-0.5 text-[10px] font-bold rounded bg-gradient-to-r from-purple-600 to-fuchsia-500 text-white cursor-help select-none">
          PRO
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[200px] text-center">
        <p className="text-xs">Exclusif aux membres Pro — Boostez votre CTR de 40% 🚀</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default ProBadge;
